import { loadState } from '../../localstorage';

const persistedState = loadState() || {};

const state = persistedState.teacher || {
	signupStatus: null,
	signupABTest: null,
	isSchoolInfoSkipped: false,
	isSchoolPageRedirected: false,
	classes: [],
	studentClasses: [],
	invites: [],
	schoolInfo: null,
	classroomInfo: null,
	isWhatsNextOverlaySeen: false,
	hideCanceledActivities: false,
}

const getters = {}

const mutations = {
	updateSignupStatus(state, status) {
		state.signupStatus = status;
	},
	updateSignupABTest(state, payload) {
		state.signupABTest = payload;
	},
	updateSchoolInfoSkipped(state, skipped) {
		state.isSchoolInfoSkipped = skipped;
	},
	updateWhatsNextOverlaySeen(state, seen) {
		state.isWhatsNextOverlaySeen = seen;
	},
	setTeacherData(state, teacherData) {
		state.classes = teacherData.classes;
		state.studentClasses = teacherData.studentClasses;
		state.invites = teacherData.invites;
	},
	updateInvites(state, invites) {
		state.invites = invites;
	},
	updateClasses(state, classes) {
		state.classes = classes;
	},
	updateSchoolInfo(state, schoolInfo) {
		state.schoolInfo = schoolInfo;
	},
	updateSchoolPageRedirected(state, isRedirected) {
		state.isSchoolPageRedirected = isRedirected;
	},
	updateClassroomInfo(state, payload) {
		state.classroomInfo = payload;
	},
	updateHideCanceledActivities(state, hideCanceledActivities) {
		state.hideCanceledActivities = hideCanceledActivities;
	},
}

const actions = {
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
